import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/services/requests.service';

export interface Warning {
  detection_datetime: string;
  keywords: string[];
  language: string;
  location: string[];
  products: string[];
  publication_datetime: string;
  score: string;
  title: string;
  _id: string;
}

@Component({
  selector: 'app-management-analytics',
  templateUrl: './management-analytics.component.html',
  styleUrls: ['./management-analytics.component.scss']
})
export class ManagementAnalyticsComponent implements OnInit {

  warnings: Warning[] = [];
  displayedWarnings: Warning[] = [];
  loadMoreCount = 6;
  startIndex = 0;

  constructor(private req: RequestService<any>) { }

  ngOnInit(): void {
    this.req.getWarnings().subscribe((res) => {
      this.warnings = res;
      console.log(this.warnings)
      this.loadInitialWarnings();
    });
  }

  loadInitialWarnings(): void {
    // Sort warnings based on detection_datetime in descending order
    this.warnings.sort((a, b) => new Date(b.detection_datetime).getTime() - new Date(a.detection_datetime).getTime());

    // Display the first set of 6 warnings
    this.displayedWarnings = this.warnings.slice(this.startIndex, this.startIndex + this.loadMoreCount);
    this.startIndex += this.loadMoreCount;
  }

  showMore(): void {
    // Display the next set of 6 warnings
    this.displayedWarnings = [...this.displayedWarnings, ...this.warnings.slice(this.startIndex, this.startIndex + this.loadMoreCount)];
    this.startIndex += this.loadMoreCount;
  }
}
